module.exports = __webpack_public_path__ + "static/media/texture-green.dbe4a7a6.png";